<template>
  <div id="layout-wrapper" class="page-topbar-horizontal">
    <TopBar :type="'light'" :width="'fluid'" />

    <main class="main-content" id="main-content" tabindex="-1">
      <div class="page-content mb-5">
        <div class="container-fluid p-mobile">

          <div class="err-page-ese">
            <div class="err-illustration-ese" aria-hidden="true">
              <svg viewBox="0 0 220 180" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="110" cy="160" rx="86" ry="10" fill="#e9ede6" />

                <g>
                  <path d="M44 78 L176 78 L166 148 L54 148 Z" fill="#fff" stroke="#dfe3da" stroke-width="2" />
                  <path d="M44 78 L52 60 L168 60 L176 78 Z" fill="#f3f5f0" stroke="#dfe3da" stroke-width="2" />
                  <line x1="58" y1="96" x2="162" y2="96" stroke="#e3e7de" stroke-width="2" />
                  <line x1="61" y1="114" x2="159" y2="114" stroke="#e3e7de" stroke-width="2" />
                  <line x1="64" y1="132" x2="156" y2="132" stroke="#e3e7de" stroke-width="2" />
                </g>

                <g transform="translate(75,50) rotate(-8)">
                  <circle cx="0" cy="0" r="15" fill="#5bab42" />
                  <path d="M0 -15 C 6 -22, 12 -20, 10 -13" fill="none" stroke="#3f7f2c" stroke-width="2.5" stroke-linecap="round" />
                  <path d="M-6 -5 a6 6 0 1 0 12 0 a6 6 0 1 0 -12 0" fill="#fff" opacity="0.16" />
                </g>

                <g transform="translate(150,52) rotate(10)">
                  <circle cx="0" cy="0" r="12" fill="#e9a23b" />
                  <path d="M0 -12 L1 -18" stroke="#8a6a2a" stroke-width="2.5" stroke-linecap="round" />
                </g>

                <g transform="translate(110,66)">
                  <rect x="-34" y="-13" width="68" height="26" rx="4" fill="#c9483b" stroke="#a2352a" stroke-width="1.5" />
                  <text x="0" y="7" text-anchor="middle" font-family="'IBM Plex Mono', monospace" font-size="17" font-weight="700" fill="#fff">404</text>
                </g>
              </svg>
            </div>

            <p class="err-eyebrow">
              {{ isNotFound ? 'Greška 404' : `Greška ${error?.statusCode || ''}` }}
            </p>

            <h1 class="err-title">
              {{ isNotFound ? 'Ova tezga je prazna' : 'Nešto je pošlo naopako' }}
            </h1>

            <p class="err-text">
              <template v-if="isNotFound">
                Stranica koju tražite ne postoji ili je premeštena.
                Provjerite adresu, ili pogledajte neku od stranica ispod.
              </template>
              <template v-else>
                Došlo je do neočekivane greške dok je stranica učitavana.
                Pokušajte ponovo, ili se vratite na početnu stranicu.
              </template>
            </p>

            <div class="err-actions">
              <button type="button" class="err-btn err-btn-primary" @click="goHome">
                Nazad na početnu
              </button>
              <button
                v-if="!isNotFound"
                type="button"
                class="err-btn err-btn-secondary"
                @click="handleError"
              >
                Pokušaj ponovo
              </button>
            </div>

            <div class="err-links">
              <NuxtLink to="/cena-na-pijacama" class="err-link">
                Cene na pijacama
              </NuxtLink>
              <NuxtLink to="/crkveni-kalendar" class="err-link">
                Crkveni kalendar
              </NuxtLink>
              <NuxtLink to="/oglasi" class="err-link">
                Oglasi
              </NuxtLink>
              <NuxtLink to="/kontakt" class="err-link">
                Kontakt
              </NuxtLink>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </main>
  </div>
</template>

<script setup>
import TopBar from "~/components/layouts/horizontal/TopBar.vue"
import Footer from "~/components/layouts/common/Footer.vue"

const props = defineProps({
  error: {
    type: Object,
    default: null
  }
})

const isNotFound = computed(() => Number(props.error?.statusCode) === 404)

useHead({
  title: isNotFound.value ? 'Stranica nije pronađena' : 'Greška',
  meta: [
    { name: 'robots', content: 'noindex, nofollow' }
  ]
})

const goHome = () => clearError({ redirect: '/' })

const handleError = () => clearError()
</script>
